export const asyncFileLoader = (source: string, callback: () => void) => {
	const script = document.createElement('script');
	script.setAttribute('src', source);
	script.setAttribute('type', 'text/javascript');
	script.addEventListener('load', callback);
	document.head.appendChild(script);
};
